<template>
    <div class="user">
        <div class="user-banner"></div>
        <div class="user-wrapper" v-if="user">
            <!-- 用户信息 -->
            <div class="user-info">
                <div class="user-brief">
                    <div class="user-brief-item">
                        <div class="num">{{ user.zuoPinCount }}</div>
                        <div class="title">作品</div>
                    </div>
                    <router-link tag="div" :to="{ name: 'Follow', params: { type: 0, id: user.id } }" class="user-brief-item link">
                        <div class="num">{{ user.fansCount }}</div>
                        <div class="title">粉丝</div>
                    </router-link>
                    <router-link tag="div" :to="{ name: 'Follow', params: { type: 1, id: user.id } }" class="user-brief-item link">
                        <div class="num">{{ user.myAttentionCount }}</div>
                        <div class="title">关注</div>
                    </router-link>
                </div>
                <div class="user-avatar">
                    <img class="user-avatar-image" :src="user.imageAddress || avatarUrl" />
                    <div class="user-avatar-vip" v-if="user && user.state === 2">
                        <svg-icon icon-class="avatar_vip" class-name="icon-avatar_vip"></svg-icon>
                    </div>
                    <div class="user-avatar-vip" v-else-if="user && user.state === 3">
                        <img :src="require('@/assets/images/seed.png')" />
                    </div>
                </div>
                <div class="user-name">
                    {{ user.name || user.email }}
                </div>
                <div class="user-tag">
                    {{ user.qianMing }}
                </div>
                <div class="user-data">
                    <template v-if="isOwner">
                        <router-link target="_blank" to="/upload">
                            <el-button type="primary" class="user-data__upload-button">
                                上传作品/经验
                            </el-button>
                        </router-link>
                        <router-link tag="div" to="/userInfo">
                            <el-button type="primary" plain class="user-data__change-button">
                                修改资料
                            </el-button>
                        </router-link>
                    </template>
                    <template v-else>
                        <el-button :type="isFollow ? '' : 'primary'" size="small" class="user-data__change-button" @click="toggleFollow">
                            {{ isFollow ? '取消关注' : '关注' }}
                        </el-button>
                        <router-link tag="div" :to="`/designerInfo/${user.id}`">
                            <el-button type="primary" plain class="user-data__change-button">
                                查看资料
                            </el-button>
                        </router-link>
                    </template>
                </div>
                <!-- 彩蛋 -->
                <!-- <a href="http://magickeyboard.io/" target="_blank">
                    <div class="user-egg"></div>
                </a> -->
            </div>
            <nav class="user-navigation">
                <!-- 导航 -->
                <ul class="user-navigation__list">
                    <li
                        v-for="(item, index) in tabs"
                        :key="index"
                        class="user-navigation__list-item"
                        :class="{ active: item.type == activeType }"
                        @click="handleTab(item.type)"
                    >
                        <span>{{ item.name }}</span>
                    </li>
                </ul>
            </nav>
            <div v-if="[4,7,9,10].includes(activeType)">
                <template v-if="[7,10].includes(activeType)">
                    <div  class="order-type" v-if="activeType === 7">
                        <span v-for="type in orderTypeList" :key="type.label" :class="type.active ? 'active' : ''" @click="handleChangeOrderType(type)">{{type.label}}</span>
                    </div>
                    <source-code-list v-if="activeOrderType === 2" :type="activeType === 7 ? 'order' : 'collection'"></source-code-list>
                </template>
                
                <material-list v-if="activeOrderType==0 || [4,9].includes(activeType)" :user="user" :collected="activeType === 4" :type="activeType" ></material-list>
            </div>
            <!-- 找图片入口暂隐藏，恢复时取消注释 -->
            <!-- <div v-if="activeType === 5 || activeType === 7">
                <find-image-list v-if="!(activeType === 7 && activeOrderType !== 1)" :listType="activeType === 7 ? '3' : '2'"></find-image-list>
            </div> -->
            <div
                v-else class="card-list-wrapper">
                <card-list v-if="user" :type="activeType" :user="user"></card-list>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import MaterialList from '@/views/Material/components/MaterialList';
import SourceCodeList from '@/views/SourceCode/components/SourceCodeList';
import FindImageList from '@/views/FindImage/components/ImageList';
import debounce from 'lodash/debounce';
import { getToken } from '../../utils/auth';
import {
    getUserDetail,
    isAttentionUser,
    attentionUser,
    unAttentionUser
} from '@/api/user';
import CardList from './components/CardList';

export default {
    name: 'User',
    components: {
        MaterialList,
        SourceCodeList,
        CardList,
        FindImageList
    },
    inject: ['checkToken', 'reload'],
    data: () => {
        return {
            user: null,
            isFollow: false,
            avatarUrl: '/static/images/user.png',
            activeType: 0,
            tabs: [],
            activeOrderType:0,
            orderTypeList: [
                { label: '素材', value: 0, active: true },
                // { label: '图片', value: 1, active: false },
                { label: '源码', value: 2, active: false },
            ],
        }
    },
    computed: {
        ...mapState('user', ['userInfo']),
        isOwner() {
            let isOwner = false;
            if (this.userInfo && this.user && this.userInfo.id === this.user.id) {
                isOwner = true;
            }
            return isOwner;
        },
    },
    watch: {
        '$route'() {
            this.initUserInfo();
        },
        userInfo: {
            deep: true,
            immediate: true,
            handler(newVal) {
                let { id } = this.$route.params;
                if (!id && newVal) {
                    this.getTabs();
                }
            }
        }
    },
    created() {
    },
    mounted() {
        this.initUserInfo();
    },
    methods: {
        getTabs() {
            const tabs = [
                {
                    type: 0,
                    name: '我的作品'
                },
                {
                    type: 1,
                    name: '我的经验'
                },
                {
                    type: 2,
                    name: '收藏作品'
                },
                {
                    type: 3,
                    name: '收藏经验'
                },
                {
                    type: 4,
                    name: '收藏素材'
                },
                // {
                //     type: 5,
                //     name: '收藏图片'
                // },
                {
                    type: 10,
                    name: '收藏源码'
                },
                {
                    type: 6,
                    name: '我的草稿'
                },
                {
                    type: 7,
                    name: '我的订单'
                },
                {
                    type: 9,
                    name: '我的素材'
                },
                {
                    type: 8,
                    name: '素材投稿'
                }
            ];
            // if (this.userInfo.projectPriv) {
            //     tabs.splice(2, 0, {
            //         type: 5,
            //         name: '我的企业案例'
            //     });
            // }
            // 只有创作者才有我的素材入口
            if (!this.userInfo.bindAuthorFlag) {
                tabs.splice(9, 1);
            }
            this.tabs = tabs;

        },
        initUserInfo() {
            let { id } = this.$route.params;
            let { type } = this.$route.query;

            if (id) { // 查看其他用户的个人中心
                getUserDetail({ userId: id }).then(async ({ code, data }) => {
                    if (code === 0) {
                        this.user = data;
                        this.tabs = [
                            {
                                type: 0,
                                name: `Ta的作品 ${data.zuoPinCount}`
                            },
                            {
                                type: 1,
                                name: `Ta的经验 ${data.articleCount}`
                            },
                            {
                                type: 2,
                                name: `Ta收藏的作品 ${data.collectionZuoPinCount}`
                            },
                            {
                                type: 3,
                                name: `Ta收藏的经验 ${data.collectionArticleCount}`
                            }
                        ];
                        if (getToken()) {
                            await this.$store.dispatch('user/getUserInfo');
                            this.isAttentionUser();
                        }
                    }
                });
            } else if (!id && getToken()) {
                this.$store.dispatch('user/getUserInfo').then(() => {
                    this.user = Object.assign({}, this.userInfo);
                });
            } else {
                this.$message.error('请先登录');
                this.$router.push({ name: 'Login' });
                return;
            }

            this.activeType = +type || 0;
        },
        handleTab(type) {
            this.activeType = type;
            if (type == 10) {
                this.activeOrderType = 2
            }
            if (type == 4) {
                this.activeOrderType = 0
            }
        },
        isAttentionUser() {
            if (this.userInfo && this.user) {
                isAttentionUser({ attentionUserId: this.user.id, userId: this.userInfo.id}).then(({ code, data }) => {
                    if (code === 0) {
                        this.isFollow = data;
                    }
                });
            }
        },
        /**
         * 点击修改草稿显示类型
         * @params type 草稿显示类型
         */
        handleChangeOrderType(type) {
            this.orderTypeList.forEach(item => {
                item.active = type.value === item.value;
            });
            this.activeOrderType = type.value
        },
        toggleFollow: debounce(function (){
            if (this.checkToken()) {
                if (!this.isFollow) {
                    attentionUser({ attentionUserId: this.user.id, userId: this.userInfo.id}).then(({ code }) => {
                        if (code === 0) {
                            this.$message.success('关注成功');
                        }
                    }).finally(() => {
                        this.isFollow = true;
                    });
                } else {
                    unAttentionUser({ attentionUserId: this.user.id, userId: this.userInfo.id}).then(({ code }) => {
                        if (code === 0) {
                            this.$message.success('已取消关注');
                        }
                    }).finally(() => {
                        this.isFollow = false;
                    });
                }
            }
        }, 300),
    }
};
</script>

<style lang="scss" scoped>
.user {
    overflow: hidden;
    position: relative;
    min-width: 1600px;

    .user-banner {
        position: absolute;
        width: 100%;
        height: 220px;
        top: 0;
        left: 0;
        background: url('../../assets/images/userBanner.png') center no-repeat;
        background-size: 100% 100%;
    }

    .user-wrapper {
        margin: 0 auto;
        width: 1600px;
    }

    .user-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 1600px;
        height: 440px;
        margin: 35px auto;
        position: relative;
        z-index: 2;

        .user-brief {
            display: flex;
            justify-content: space-between;
            width: 200px;
            margin-top: 60px;

            &-item {
                text-align: center;
                transition: opacity .3s;

                &.link {
                    cursor: pointer;
                }

                &:hover {
                    opacity: 0.8;
                }

                .num {
                    @include font(rgba(245, 246, 249, 1), 20px, 600);
                }

                .title {
                    margin-top: 4px;
                    @include font(rgba(113, 119, 152, 1), 14px, 400);
                }
            }
        }

        .user-avatar {
            position: relative;
            width: 100px;
            height: 100px;
            margin-top: 30px;

            &-image {
                box-sizing: border-box;
                width: 100%;
                height: 100%;
                border: 3px solid rgba(237, 237, 237, 1);
                border-radius: 50%;
            }

            &-vip {
                position: absolute;
                right: -32px;
                top: -10px;

                .icon-avatar_vip {
                    color: #fff;
                    font-size: 32px;
                }
            }
        }

        .user-name {
            margin-top: 20px;
            @include font(rgba(39, 44, 64, 1), 18px, 600);
        }

        .user-tag {
            margin-top: 10px;
            @include font(rgba(39, 44, 64, 1), 14px, 400);
        }

        .user-egg {
            position: absolute;
            top: 50px;
            right: 4px;
            width: 170px;
            height: 134px;
            background: url('../../assets/images/egg.png') no-repeat;
            background-size: 100% 100%;

            &:hover {
                background: url('../../assets/images/egg-active.png') no-repeat;
                background-size: 100% 100%;
            }
        }

        .user-data {
            position: absolute;
            top: 200px;
            right: 4px;
            width: 140px;

            &__change-button {
                width: 140px;
                height: 40px;
                margin-top: 20px;
                font-size: 16px;
            }
            &__upload-button {
                width: 140px;
                height: 40px;
                margin-top: 20px;
                @include font(rgba(255, 255, 255, 1), 16px, 400);
            }
        }
    }

    .user-navigation {
        padding-bottom: 16px;
        border-bottom: 1px solid rgba(216, 216, 216, 1);

        &__list {
            display: flex;
            justify-content:center;
            width: 700px;
            height: 24px;
            margin: 0 auto;

            &-item {
                @include font(rgba(113, 119, 152, 1), 16px, 400);
                cursor: pointer;
                margin-right: 20px;
                white-space: nowrap;
                &:last-child {
                    margin-right: 0;
                }

                &:hover,
                &.active {
                    @include font(rgba(47, 84, 235, 1), 16px, 400);
                }
            }
        }
    }
    .order-type {
        margin-top: 20px;
        height: 40px;
        line-height: 40px;
        &>span {
            margin-right: 20px;
            padding: 5px 15px;
            border-radius: 25px;
            border: 1px solid #2F54EB;
            color: #2F54EB;
            cursor: pointer;
            &.active {
                background-color: #2F54EB;
                border: 1px solid #2F54EB;
                color: #fff;
                &:hover {
                    border: 1px solid #2F54EB;
                    color: #fff;
                }
            }
            &:hover {
                border: 1px solid #A8ADC1;
                color: #A8ADC1;
            }
        }
    }

    .card-list-wrapper {
        width: 1600px;
        margin: 0 auto;
    }
}

// 小屏
@include mq($small) {
    .user {
        min-width: 1200px;
        .user-wrapper {
            width: 1200px;
        }

        .user-info {
            width: 1200px;
            height: 440px;

            .user-name {
                @include font(rgba(39, 44, 64, 1), 14px, 600);
            }

            .user-tag {
                @include font(rgba(39, 44, 64, 1), 12px, 400);
            }
        }

        .user-navigation {
            &__list {
                height: 18px;
                &-item {
                    @include font(rgba(113, 119, 152, 1), 14px, 400);

                    &:hover,
                    &.active {
                        @include font(rgba(47, 84, 235, 1), 14px, 400);
                    }
                }
            }
        }

        .card-list-wrapper {
            width: 1200px;
            margin: 0 auto;
        }
    }
}
</style>
